/* AMARA ORACLE — theme interactions
   Ported from the static site. Cart, pricing and checkout are now Shopify's;
   what remains is the presentation layer:
   mobile nav · nav dropdowns · FAQ accordion · testimonial rotator ·
   reveal-on-scroll · product-form notes/photo · cart line updates · footer year */
(function () {
  "use strict";

  var body = document.body;

  /* ---- Mobile navigation ---- */
  var toggle = document.querySelector(".nav-toggle");
  if (toggle) {
    toggle.addEventListener("click", function () {
      var open = body.classList.toggle("nav-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!body.classList.contains("nav-open")) return;
      if (e.target.closest(".nav a") || e.target.classList.contains("nav-scrim")) {
        body.classList.remove("nav-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && body.classList.contains("nav-open")) {
        body.classList.remove("nav-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---- Category-page context propagation ----
     filter-bar.liquid stamps ?from=readings|spellwork on chips it renders with
     a known context (homepage quick-links, each hub's own filter bar). Individual
     category collection pages (main-collection.liquid) don't know their own
     family server-side, so their "All" chip falls back to the generic
     /collections/all page. Read ?from= back out here and fix that chip (plus
     propagate the param onto sibling chips so it stays sticky across clicks).
     Nav-dropdown links don't carry ?from= at all (that menu is Shopify
     Admin-managed, not in this repo) — for categories that unambiguously
     belong to only one hub, fall back to a static lookup instead of guessing
     wrong. love/fortune/spirit are members of both hubs' category sets and
     stay ambiguous without ?from=, same as before this fix. */
  var CATEGORY_HUB = {
    insight: "readings",
    protection: "spellwork", cleansing: "spellwork", healing: "spellwork",
    custom: "spellwork", spells: "spellwork", rituals: "spellwork"
  };
  var filterBar = document.querySelector(".filter-bar");
  if (filterBar) {
    var fromCtx = new URLSearchParams(location.search).get("from");
    if (!fromCtx) fromCtx = CATEGORY_HUB[body.dataset.collectionHandle];
    if (fromCtx === "readings" || fromCtx === "spellwork") {
      var hubUrl = fromCtx === "readings" ? body.dataset.readingsUrl : body.dataset.spellworkUrl;
      var allChip = filterBar.querySelector('[data-filter="all"]');
      if (allChip && hubUrl) allChip.setAttribute("href", hubUrl);
      filterBar.querySelectorAll(".filter-chip").forEach(function (chip) {
        if (chip === allChip) return;
        var href = chip.getAttribute("href");
        if (href && href.indexOf("from=") === -1) {
          chip.setAttribute("href", href + (href.indexOf("?") === -1 ? "?" : "&") + "from=" + fromCtx);
        }
      });
    }
  }

  /* ---- Nav dropdown toggles ---- */
  function closeNavGroups(except) {
    document.querySelectorAll(".nav-group.is-open").forEach(function (g) {
      if (g === except) return;
      g.classList.remove("is-open");
      var t = g.querySelector(".nav-group-toggle");
      if (t) t.setAttribute("aria-expanded", "false");
    });
  }
  document.querySelectorAll(".nav-group-toggle").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var group = btn.closest(".nav-group");
      if (!group) return;
      closeNavGroups(group);                       // only one submenu open at a time
      var open = group.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = document.querySelector(".nav-group.is-open");
    if (!open) return;
    var t = open.querySelector(".nav-group-toggle");
    closeNavGroups();
    if (t) t.focus();                              // don't strand focus in a closed menu
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nav-group")) closeNavGroups();
  });

  /* ---- FAQ accordion (also drives the reviews list) ---- */
  document.querySelectorAll(".faq-q").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      if (panel) panel.style.maxHeight = expanded ? null : panel.scrollHeight + "px";
    });
  });

  /* ---- Testimonial rotator ---- */
  var testiWrap = document.querySelector(".testi-wrap");
  if (testiWrap) {
    var slides = Array.prototype.slice.call(testiWrap.querySelectorAll(".testi"));
    var dotsBox = testiWrap.querySelector(".testi-dots");
    var progressBar = testiWrap.querySelector(".testi-progress");
    var current = 0, timer = null;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var dots = slides.map(function (_, i) {
      var d = document.createElement("button");
      d.type = "button";
      d.setAttribute("aria-label", "Show testimonial " + (i + 1));
      d.addEventListener("click", function () { show(i); restart(); });
      if (dotsBox) dotsBox.appendChild(d);
      return d;
    });
    function show(i) {
      slides[current].classList.remove("is-active");
      if (dots[current]) dots[current].classList.remove("is-active");
      current = (i + slides.length) % slides.length;
      slides[current].classList.add("is-active");
      if (dots[current]) dots[current].classList.add("is-active");
    }
    function restart() {
      if (reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, 6000);
      if (progressBar) {
        progressBar.classList.remove("is-animating");
        void progressBar.offsetWidth; // force reflow so the fill animation replays
        progressBar.classList.add("is-animating");
      }
    }
    if (slides.length) { show(0); restart(); }
  }

  /* ---- Reveal on scroll (fail-open: listings/content always appear) ---- */
  var reveals = document.querySelectorAll(".reveal");
  function revealEl(el) { el.classList.add("is-in"); }
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { revealEl(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -5% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
    // Safety net — nothing stays hidden even if the observer misfires.
    setTimeout(function () {
      var stuck = 0;
      reveals.forEach(function (el) {
        if (!el.classList.contains("is-in")) { revealEl(el); stuck++; }
      });
      if (!stuck) io.disconnect();
    }, 1600);
  } else {
    reveals.forEach(revealEl);
  }

  /* ---- Animated stat counters (homepage trust row) ----
     HTML keeps the real final text (e.g. "2,800+") so a page with JS disabled
     or blocked shows the correct number with no animation at all — the count-up
     only ever replaces text once it's actually running. */
  var counters = document.querySelectorAll("[data-count]");
  if (counters.length) {
    var reduceMotionCount = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var finalCountText = function (el) {
      var n = parseInt(el.getAttribute("data-count"), 10) || 0;
      return n.toLocaleString() + (el.getAttribute("data-suffix") || "");
    };
    if (!reduceMotionCount && "IntersectionObserver" in window) {
      var countUp = function (el) {
        var target = parseInt(el.getAttribute("data-count"), 10) || 0;
        var suffix = el.getAttribute("data-suffix") || "";
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic, matches --ease-out's feel
          el.textContent = Math.round(target * eased).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      };
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
      // Fail-open, matching .reveal: a counter can never get stuck mid-count.
      setTimeout(function () {
        counters.forEach(function (el) {
          if (el.textContent !== finalCountText(el)) el.textContent = finalCountText(el);
        });
      }, 2600);
    }
  }

  /* ---- Product form: require the notes the working depends on ---- */
  var pform = document.querySelector("form[data-product-form]");
  if (pform) {
    var notes = pform.querySelector(".pf-notes");
    var photo = pform.querySelector(".pf-photo");
    // Shopify caps a line-item property at 4096 characters; warn before the cart does.
    if (notes) {
      var counter = pform.querySelector(".pf-count");
      var MAX = 4000;
      var sync = function () {
        var n = notes.value.length;
        if (counter) {
          counter.textContent = n + " / " + MAX;
          counter.classList.toggle("is-over", n > MAX);
        }
        notes.setCustomValidity(n > MAX ? "Please shorten this to " + MAX + " characters or fewer." : "");
      };
      notes.addEventListener("input", sync);
      sync();
    }
    // Shopify rejects uploads over 20MB on a line-item property.
    if (photo) {
      photo.addEventListener("change", function () {
        var f = photo.files && photo.files[0];
        var note = pform.querySelector(".pf-photo-note");
        if (f && f.size > 20 * 1024 * 1024) {
          photo.setCustomValidity("That photo is over 20MB. Please choose a smaller one.");
          if (note) note.textContent = "That photo is over 20MB — please choose a smaller one.";
        } else {
          photo.setCustomValidity("");
          if (note && f) note.textContent = "Attached: " + f.name;
        }
      });
    }

    /* AJAX add-to-cart: stay on the product page, keep whatever the customer has
       already added, and let them keep browsing (or click through via the buttons
       below the CTA). Falls back to a normal form submit if fetch fails. */
    if (pform.hasAttribute("data-ajax-add")) {
      var addBtn = pform.querySelector("[data-add-btn]");
      var idle = pform.querySelector("[data-idle]");
      var loading = pform.querySelector("[data-loading]");
      var done = pform.querySelector("[data-done]");
      var status = pform.querySelector("[data-add-status]");
      var setBtnState = function (state) {
        if (idle) idle.hidden = state !== "idle";
        if (loading) loading.hidden = state !== "loading";
        if (done) done.hidden = state !== "done";
        if (addBtn) addBtn.disabled = state === "loading";
      };
      pform.addEventListener("submit", function (e) {
        if (!pform.checkValidity()) return;
        e.preventDefault();
        setBtnState("loading");
        var data = new FormData(pform);
        fetch("/cart/add.js", { method: "POST", body: data, headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { throw j; }); })
          .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) {
            var el = document.querySelector(".cart-count");
            if (el) {
              if (cart.item_count === 0) el.setAttribute("hidden", "");
              else { el.removeAttribute("hidden"); el.textContent = cart.item_count; }
            }
            setBtnState("done");
            if (status) status.hidden = false;
            setTimeout(function () { setBtnState("idle"); }, 3500);
          })
          .catch(function (err) {
            setBtnState("idle");
            var msg = (err && err.description) || (err && err.message) || "Something interrupted the add — try once more.";
            alert(msg);
          });
      });
    }
  }

  /* ---- Cart page: quantity stepper + remove, via Shopify's Ajax Cart API ---- */
  var cartLines = document.querySelector("[data-cart-lines]");
  if (cartLines) {
    var money = function (cents) {
      return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    };
    var setCartCount = function (count) {
      var el = document.querySelector(".cart-count");
      if (!el) return;
      if (count === 0) {
        el.setAttribute("hidden", "");
      } else {
        el.removeAttribute("hidden");
        el.textContent = count > 9 ? "9+" : count;
      }
    };
    cartLines.addEventListener("click", function (e) {
      var btn = e.target.closest(".qty-increase, .qty-decrease, .cart-item-remove");
      if (!btn || btn.disabled) return;
      var key = btn.getAttribute("data-key");
      if (!key) return;
      var itemEl = cartLines.querySelector('[data-line-item="' + key + '"]');
      var valueEl = cartLines.querySelector('[data-qty-value="' + key + '"]');
      var priceEl = cartLines.querySelector('[data-line-price="' + key + '"]');
      // Shopify reissues this line's key on every mutation (it hashes in the
      // active discount allocation alongside the line-item properties), so
      // the key is only valid for THIS one request. Match the response back
      // to our line by position, not by key — index is stable across a
      // same-line quantity change since no other lines are added/removed.
      var itemIndex = itemEl ? Array.prototype.indexOf.call(cartLines.children, itemEl) : -1;
      var current = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
      var next = btn.classList.contains("qty-increase") ? current + 1
        : btn.classList.contains("qty-decrease") ? Math.max(0, current - 1)
        : 0;
      var groupButtons = itemEl ? itemEl.querySelectorAll(".qty-btn, .cart-item-remove") : [btn];
      groupButtons.forEach(function (b) { b.disabled = true; });
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(function (r) {
          // A non-2xx here (e.g. a stale key slipping through anyway) is a
          // real error, not an empty cart — don't let it fall into the
          // empty-cart branch below, which used to happen because the error
          // body has no `items` key either, so `!cart.items` was true for
          // both "genuinely empty" and "the request just failed."
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) {
            // Was window.location.reload() — a full navigation is what read as
            // "the page refreshes" when the last item's qty hit 0. The cart is
            // already empty per this response, so just swap the pre-rendered
            // states instead of a round-trip reload.
            var form = document.querySelector(".cart-form");
            var empty = document.querySelector(".cart-empty");
            if (form) form.setAttribute("hidden", "");
            if (empty) empty.removeAttribute("hidden");
            var savingsElEmpty = document.querySelector("[data-savings-banner]");
            if (savingsElEmpty) savingsElEmpty.setAttribute("hidden", "");
            setCartCount(0);
            return;
          }
          if (next === 0) {
            if (itemEl) itemEl.remove();
          } else {
            var line = itemIndex > -1 ? cart.items[itemIndex] : null;
            if (valueEl) valueEl.textContent = next;
            if (priceEl && line) priceEl.textContent = money(line.final_line_price);
            if (line) {
              // Resync every data-key-bearing attribute on this line to the
              // fresh key so the NEXT click doesn't fire against an orphaned
              // one (that was the actual cause of the "goes empty" bug).
              key = line.key;
              groupButtons.forEach(function (b) { b.setAttribute("data-key", key); });
              if (itemEl) itemEl.setAttribute("data-line-item", key);
              if (valueEl) valueEl.setAttribute("data-qty-value", key);
              if (priceEl) priceEl.setAttribute("data-line-price", key);
            }
            groupButtons.forEach(function (b) { b.disabled = false; });
          }
          var subtotalEl = document.querySelector("[data-cart-subtotal]");
          var totalEl = document.querySelector("[data-cart-total]");
          if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
          if (totalEl) totalEl.textContent = money(cart.total_price);
          setCartCount(cart.item_count);
          var savingsEl = document.querySelector("[data-savings-banner]");
          var savingsAmountEl = document.querySelector("[data-savings-amount]");
          var savingsPctEl = document.querySelector("[data-savings-pct]");
          if (savingsEl && savingsAmountEl) {
            if (cart.total_discount > 0) {
              savingsEl.removeAttribute("hidden");
              savingsAmountEl.textContent = money(cart.total_discount);
              if (savingsPctEl) {
                // Same ratio the initial Liquid render computes from
                // cart.total_price/cart.total_discount, so the number never
                // drifts between a fresh page load and a qty-stepper update.
                var preDiscountTotal = cart.total_price + cart.total_discount;
                var pct = preDiscountTotal > 0 ? Math.round((cart.total_discount / preDiscountTotal) * 100) : 0;
                savingsPctEl.textContent = pct + "%";
              }
            } else {
              savingsEl.setAttribute("hidden", "");
            }
          }
        })
        .catch(function () {
          groupButtons.forEach(function (b) { b.disabled = false; });
        });
    });
  }

  /* ---- Footer year ---- */
  var yr = document.getElementById("year");
  if (yr) yr.textContent = new Date().getFullYear();
})();
